module.exports = __webpack_public_path__ + "img/belarus.08347001.svg";